<template>
    <EmployeeViewRequest></EmployeeViewRequest>
</template>
<script>
    import EmployeeViewRequest from '@/components/EmployeeProcess75Liquidation.vue'
    export default {
        name: 'employee-process-request',
        components: {
            EmployeeViewRequest
        }
    }
</script>